import React, { FC, useEffect, useState } from "react"
import { StreamTrackMonth, TrendTopTrack } from "../../../../types"
import { KSpan } from "kahuna-base-react-components"
import NotFound from "../../../NotFound"
import { lang } from "../../../../constants/languages"
import { formatNumber } from "../../../../utility"
import InfiniteScroll from "react-infinite-scroll-component"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"

type StreamsTrackMonthsProps = {
  streamsTrackMonths: StreamTrackMonth[]
}

const StreamsTrackMonths: FC<StreamsTrackMonthsProps> = (props) => {
  const { streamsTrackMonths } = props

  const [platformOptions, setPlatformOptions] = useState<KSelectOption[]>([])
  const [hoverId, setHoverId] = useState<string>()
  const [items, setItems] = useState<StreamTrackMonth[]>([])
  const [hasMore, setHasMore] = useState(true)
  const ITEMS_PER_LOAD = 200 // load 20 items at a time

  useEffect(() => {
    // initial load
    setItems(streamsTrackMonths.slice(0, ITEMS_PER_LOAD))
    setHasMore(true)
  }, [streamsTrackMonths])

  const fetchMoreData = () => {
    const nextItems = streamsTrackMonths.slice(items.length, items.length + ITEMS_PER_LOAD)
    setItems((prev) => [...prev, ...nextItems])
    if (items.length + nextItems.length >= streamsTrackMonths.length) {
      setHasMore(false) // no more items to load
    }
  }

  return (
    <div className="w-full h-full">
      <div
        className="py-5 px-7 min-h-[100%]"
        style={{
          borderRadius: "10px",
          border: "1px solid var(--stroke-soft-200, #F3F3F3)",
          background: "var(--bg-white-0, #FFF)",
          boxShadow: "0px 2px 4px 0px rgba(27, 28, 29, 0.04)"
        }}
      >
        <div>
          <div className="flex mb-4" style={{ width: "100%" }}>
            <div style={{ width: "26%" }}>
              <KSpan color="#111" text={"Track Title"} />
            </div>
            <div style={{ width: "26%" }}>
              <KSpan color="#111" text={"Artist(s)"} />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan color="#111" text={"60–90 Days Ago"} />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan color="#111" text={"30–60 Days Ago"} />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan color="#111" text={"Last 30 Days"} />
            </div>
            <div style={{ width: "9%" }}>
              <KSpan color="#111" text={"Total"} />
            </div>
          </div>
          {streamsTrackMonths && !(streamsTrackMonths.length > 0) && (
            <div className="flex p-5 w-full justify-center mt-[100px]">
              <NotFound title={lang.not_found.trends.title} description={lang.not_found.trends.desc} imageWidth={400} />
            </div>
          )}
          <div className="flex p-2" style={{ width: "100%", background: "#00000008", borderRadius: "5px" }}>
            <div style={{ width: "52%" }}>
              <KSpan fontWeight={600} color="#111" text={"TOTAL"} />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan
                fontWeight={600}
                color="#111"
                text={formatNumber(
                  streamsTrackMonths?.reduce((sum, item) => sum + (item.streamsThreeMonths || 0), 0) || 0
                )}
              />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan
                fontWeight={600}
                color="#111"
                text={formatNumber(
                  streamsTrackMonths?.reduce((sum, item) => sum + (item.streamsLastMonth || 0), 0) || 0
                )}
              />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan
                fontWeight={600}
                color="#111"
                text={formatNumber(
                  streamsTrackMonths?.reduce((sum, item) => sum + (item.streamsThisMonth || 0), 0) || 0
                )}
              />
            </div>
            <div style={{ width: "9%" }}>
              <KSpan
                fontWeight={600}
                color="#111"
                text={formatNumber(streamsTrackMonths?.reduce((sum, item) => sum + (item.total || 0), 0) || 0)}
              />
            </div>
          </div>
          <InfiniteScroll
            dataLength={items.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={<h4>Loading...</h4>}
            height={600} // you can adjust the scrollable height
            endMessage={
              <div className="mt-4" style={{ textAlign: "center" }}>
                <KSpan text="No more tracks" />
              </div>
            }
          >
            {items.map((StreamTrackMonth) => {
              const background = hoverId === StreamTrackMonth.isrc ? "#00000008" : "transparent"
              return (
                <div
                  className="flex p-2"
                  style={{ width: "100%", background, borderRadius: "5px" }}
                  key={`trend_top_track_${StreamTrackMonth.isrc}}`}
                  onMouseOver={() => setHoverId(StreamTrackMonth.isrc)}
                >
                  <div style={{ width: "26%" }}>
                    <KSpan text={StreamTrackMonth.track?.title || "-"} />
                  </div>
                  <div style={{ width: "26%" }}>
                    <KSpan text={StreamTrackMonth.track?.artistList?.map((artist) => artist.name)?.join(", ") || "-"} />
                  </div>
                  <div style={{ width: "13%" }}>
                    <KSpan text={formatNumber(StreamTrackMonth.streamsThreeMonths || 0)} />
                  </div>
                  <div style={{ width: "13%" }}>
                    <KSpan text={formatNumber(StreamTrackMonth.streamsLastMonth || 0)} />
                  </div>
                  <div style={{ width: "13%" }}>
                    <KSpan text={formatNumber(StreamTrackMonth.streamsThisMonth || 0)} />
                  </div>
                  <div style={{ width: "9%" }}>
                    <KSpan text={formatNumber(StreamTrackMonth.total || 0)} />
                  </div>
                </div>
              )
            })}
          </InfiniteScroll>
        </div>
      </div>
    </div>
  )
}

export default StreamsTrackMonths
